/**
 * @description 获取会员首页 banner 图
 * @returns { Object } axios 配置
 */
export const getIndexBanner = () => {
  return {
    url: '/api/channels/vip/banner',
    method: 'get',
  };
};

/**
 * @description 获取文章 tab 列表
 * @param { String } type 查找列表类型
 * @returns { Object } axios 配置
 */
export const getIndexTab = type => {
  return {
    url: '/api/channels/v3',
    method: 'get',
    params: {
      ...type,
    },
  };
};

/**
 * @description 获取文章 tab 列表
 * @param { String } channel 查找列表类型
 * @returns { Object } axios 配置
 */
export const getIndexTabByChannel = channel => {
  return {
    url: `/api/channels/${channel}/v1`,
    method: 'get',
  };
};

/**
 * @description 获取文章 tab 列表
 * @param { String } channel 查找列表类型
 * @returns { Object } axios 配置
 */
export const getSvipTab = channel => {
  return {
    url: '/api/channels/subChannels/v1',
    method: 'get',
    params: {
      ...channel,
    },
  };
};

/**
 * @description 获取会员文章
 * @param { String } vipAlbum 文章类型
 * @param { Boolea } isUnlocked 是否解锁
 * @param { Number } limit 最大限制数
 * @param { Number } timestamp 开始日期
 * @returns { Object } axios 配置
 */
export const getIndexColumns = ({
  vipAlbum,
  isUnlocked = false,
  timestamp = null,
  limit,
}) => {
  return {
    url: '/api/vips/articles/v3',
    method: 'get',
    params: {
      vipAlbum,
      isUnlocked,
      timestamp,
      limit,
    },
  };
};

/**
 * @description 获取会员首页付费栏目列表
 * @param { Number } limit 限制数
 * @returns { Object } axios 配置
 */
export const getIndexColumnCard = (limit = 15) => {
  return {
    url: '/api/shop-columns/v3',
    method: 'get',
    params: {
      limit,
    },
  };
};

/**
 * @description 获取会员首页展示数据
 * @returns { Object } axios 配置
 */
export const getVipHomePage = () => {
  return {
    url: '/api/vips/home-page/v6',
    method: 'get',
  };
};

/**
 * @description 获取用户会员权益时长
 * @returns { Object } axios 配置
 */
export const getMemberDetail = () => {
  return {
    url: '/api/vips/expiration-date/v2',
    method: 'get',
  };
};

/**
 * @description 过去订单详情
 * @param { Number } specsId 商品 id
 * @param { Boolean } onlyVip 是否为开通会员
 * @returns { Object } axios 配置
 */
export const getGoodsDetail = (specsId, onlyVip = false) => {
  return {
    url: '/api/purchase/goods-list/v7',
    method: 'get',
    headers: {
      shortversion: '9.13.0',
    },
    params: {
      specsId,
      onlyVip,
    },
  };
};

/**
 * @description 获取用户会员权益时长
 * @returns { Object } axios 配置
 */
export const getMemberChanceNotice = params => {
  return {
    url: '/api/opportunityRemind/list/v1',
    method: 'get',
    params,
  };
};

/*
 * @description 获取会员首页列表
 */
export const getMemberIndexInfo = () => {
  return {
    url: '/api/vips/home-page/v6',
    method: 'get',
  };
};

/*
 * @description 获取会员首页列表
 */
export const getMemberIndexV8 = () => {
  return {
    url: '/api/vips/home-page/v8',
    method: 'get',
  };
};

/**
 * @description 获取文章聚合详情页文章列表
 */
export const getArticlesList = (
  vipAlbum,
  timestamp = '',
  isUnlocked = false,
  limit = 30
) => {
  return {
    url: `/api/vips/articles/v2?timestamp=${timestamp}&isUnlocked=${isUnlocked}&vipAlbum=${vipAlbum}&limit=${limit}`,
    method: 'get',
  };
};

/**
 * @description 获取文章聚合详情页头部
 */
export const getColumnHead = groupId => {
  return {
    url: `/api/featured/head/${groupId}`,
    method: 'get',
  };
};

/**
 * @description 获取所有新栏目列表
 */
export const getAllColumnHead = () => {
  return {
    url: '/api/featured/all/head',
    method: 'get',
  };
};

/**
 * @description 获取文章聚合详情页精华内容
 */
export const getPrimeArticles = () => {
  return {
    url: '/api/featured/list/selectedContent',
    method: 'get',
  };
};

/**
 * @description 获取核心资产页面的个股研究列表
 */
export const getIndividualStocks = (timestamp = '', limit = 20) => {
  return {
    url: `/api/core-asset/individual-stock/v1?timestamp=${timestamp}&limit=${limit}`,
    method: 'get',
  };
};

/**
 * @description 获取个股详情
 * @param { object } params 请求参数
 */
export const getCoreCapitalStockDetail = params => {
  return {
    url: '/data/api/member/coreCapital/detail',
    method: 'get',
    params,
  };
};

/**
 * @description 获取个股详情列表
 * @param { string } id 股票id
 * @param { object } params 请求参数
 */
export const getCoreCapitalStockList = (id, params) => {
  return {
    url: `/api/core-asset/individual-stock/${id}/v1`,
    method: 'get',
    params,
  };
};

/**
 * @description 获取行业龙头列表
 */
export const getCoreCapitalList = () => {
  return {
    url: '/data/api/member/coreCapital',
    method: 'get',
  };
};

/**
 * @description 获取个股数据（股价，涨跌值，涨跌幅，单位）
 */
export const getStockDetail = params => {
  return {
    url: '/hq/stock-currency/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 获取会员首页数据
 */
export const getMemberIndex = () => {
  return {
    url: '/api/vips/contents/v1',
    method: 'get',
  };
};

/**
 * @description 检查手机三要素
 * @param { object } params 请求参数
 */
export const checkMobileMeta = params => {
  return {
    url: '/api/check/mobile-meta/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 检查大陆身份信息两要素
 * @param { object } params 请求参数
 */
export const checkMobileMetaV2 = params => {
  return {
    url: '/api/check/mobile-meta/v2',
    method: 'get',
    params,
  };
};

/**
 * @description 检查港澳台身份信息
 * @param { object } params 请求参数
 */
export const checkMobileMetaHK = params => {
  return {
    url: '/api/check/mobile-meta-hk/v1',
    method: 'get',
    params,
  };
};

/**
 * @description 查询实名认证详情
 */
export const getRealNameAuthentication = () => {
  return {
    url: '/api/real-name/authentication/v1',
    method: 'get',
  };
};

/**
 * @description 提交实名认证
 */
export const saveInvestorInfo = () => {
  return {
    url: '/api/questionnaire/investor/v1',
    method: 'post',
  };
};

/**
 * @description 获取是否展示行业龙头
 */
export const getIndustryLeaderCheck = () => {
  return {
    url: '/api/industry-leader/check/v1',
    method: 'get',
  };
};

/**
 * @description 获取是否展示盘中聊天室
 */
export const getChatroomCheck = () => {
  return {
    url: '/api/chatroom/check/v1',
    method: 'get',
  };
};

/**
 * @description 实名认证
 * @param { object } data 请求参数
 */
export const realNameAuthentication = data => {
  return {
    url: '/api/real-name/authentication/v1',
    method: 'post',
    data,
  };
};

/**
 * @description 资产配置
 * @param { number } refId 测评结果id
 */
export const getAssetAllocation = refId => {
  return {
    url: `/api/asset-allocation/${refId}/v1`,
    method: 'get',
  };
};
